<template>
  <div class="iphone-activity-form">
    <h2 class="iphone-activity-title">获取降本增效方案</h2>
    <div class="form" style="overflow: hidden">
      <div class="form-item">
        <input type="text" id="sem-from-name" class="activity-input" placeholder="请输入您的姓名" disabled />
      </div>

      <div class="form-item">
        <input
          type="text"
          id="sem-from-phone"
          class="activity-input"
          placeholder="请输入您的手机号"
          disabled
        />
        <span class="input-btn sem-form-phone-code-button" style="padding-right: 0.3rem">获取验证码</span>
      </div>

      <div class="form-item">
        <input
          type="text"
          class="activity-input phone_testnum"
          placeholder="请输入短信验证码"
          maxlength="6"
          disabled
        />
      </div>

      <div class="form-item">
        <input
          type="text"
          id="sem-from-corp"
          class="activity-input"
          placeholder="请输入您的公司名称"
          disabled
        />
      </div>

      <div class="form-item">
        <select class="activity-input activity-select" disabled id="sem-from-scale">
          <option value selected disabled>企业规模</option>
        </select>
      </div>
      <div class="btn">
        <a href="javascript:;" class="index-btn fk-sem-form-submit" style="width: 100%">获取定制方案</a>
      </div>

      <div class="form-check">
        <input class="fk-sem-form-check" type="checkbox" checked />
        <span>
          "我已阅读并了解"
          <a href="https://mk.yybip.com/manage/#/privacyTerms" target="_blank">《隐私政策》</a>
          ；您所填写的信息已进行安全加密。
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { formObject } from "../../../../../config/elementObject.js";
let formObjectTemp = JSON.parse(JSON.stringify(formObject));
export default {
  name: "MkFormPhone",
  props: {
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    async getCurrentForm() {
      if (this.childItem.propsValue.data.customField1) {
        let data = await this.api.form.info(
          this.childItem.propsValue.data.customField1
        );
        if (data.flag == 0 && data.data) {
          this.formInfo = data.data;
        }
      }
    }
  },
  watch: {
    "childItem.propsValue.data.customField1"() {
      this.getCurrentForm();
    }
  },
  data() {
    return {
      formInfo: {},
      fields: [
        {
          code: "customField1",
          label: "表单",
          type: "form"
        }
      ],
      data: {
        customField1: formObjectTemp
      }
    };
  }
};
</script>

<style scoped lang="scss">
.iphone-activity-form {
  padding-top: 36px;
  background: url(https://www.yonyou.com/yingxiao/gd/caiwu/qqsk/mobile/activity/images/bg17.jpg)
    no-repeat bottom left;
  background-size: 100% 100%;
  padding-bottom: 70px;
}
.iphone-activity-title {
  text-align: center;
  color: #e31924;
  line-height: 2;
  font-size: 20px;
  font-weight: bold;
}
.iphone-activity-form .sub-title {
  font-size: 12px;
  color: #6c6c6c;
  text-align: center;
}
.iphone-activity-form .form {
  padding: 30px;
}
.iphone-activity-form .form .form-item {
  line-height: 40px;
  position: relative;
  font-size: 14px;
  margin-bottom: 22px;
  background-color: #fff;
}
.iphone-activity-form .form .form-item .activity-input {
  font-size: 14px;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}
.iphone-activity-form .form .form-item .activity-input:-ms-input-placeholder,
.iphone-activity-form
  .form
  .form-item
  .activity-input:-webkit-input-placeholder {
  color: #b6b6b6;
}
.iphone-activity-form .form .form-item .input-btn {
  position: absolute;
  color: #d8d8d8;
  text-align: center;
  width: 90px;
  right: 10px;
  top: 0;
  font-size: 12px;
  padding-left: 15px;
}
.iphone-activity-form .form .form-item .input-btn::before {
  position: absolute;
  content: "";
  top: 5px;
  left: 0;
  width: 1px;
  height: 30px;
  background-color: #d8d8d8;
}
.iphone-activity-form .form .form-item .activity-input-error {
  display: none;
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 0;
}
.iphone-activity-form .form .form-item.error .activity-input {
  border-color: #e31924;
}
.iphone-activity-form .form .form-item.error .activity-input-error {
  display: block;
}
.iphone-activity-form .form .btn {
  text-align: center;
}
.iphone-activity-form .form .btn a {
  font-size: 14px;
  display: block;
  color: #fff;
  line-height: 3;
  text-align: center;
  background: linear-gradient(135deg, #e97528 0%, #e90713 100%);
  border-radius: 5px;
}
.iphone-activity-form .form .form-check {
  display: flex;
  font-size: 12px;
  color: #777777;
  font-weight: 400;
  margin-top: 10px;
}
.iphone-activity-form .form .form-check input {
  display: inline-block;
  min-width: 14px;
  height: 14px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  background: url(https://www.yonyou.com/yingxiao/gd/caiwu/qqsk/mobile/activity/images/unselect.png)
    no-repeat center center;
  background-size: 100% 100%;
  cursor: pointer;
  vertical-align: middle;
  margin-top: 1px;
  margin-right: 5px;
}
.iphone-activity-form .form .form-check input:checked {
  position: relative;
  background: url(https://www.yonyou.com/yingxiao/gd/caiwu/qqsk/mobile/activity/images/selected.png)
    no-repeat center center;
  background-size: 100% 100%;
}
.iphone-activity-form .form .form-check a {
  text-decoration: underline;
  color: #e14c46 !important;
}
</style>
